













// @ is an alias to /src
import Vue from "vue";

import GetPuzzleForm from "../components/PlayArea/GetPuzzleForm.vue";

import axios from "axios";

export default Vue.extend({
  name: "home",
  components: {
    GetPuzzleForm,
  },
  data: () => ({}),
  methods: {
    async apiTest(): Promise<void> {
      const response = await axios.get("/api/test");
      console.log(response.data);
    },
  },
  mounted() {},
});
